import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
    
    selectedTabIndex: number;
    headerTabBarList: any[] = [];
    collapedSideBar: boolean;

    constructor(public router: Router) {}

    ngOnInit() {
        this.headerTabBarList = JSON.parse(localStorage.getItem("tabBarList"));
        this.moveToSelectedTabPage();
    }

    receiveCollapsed($event) {
        this.collapedSideBar = $event;
    }
    
    selectedTab($event)
    {
        if(this.headerTabBarList != null)
        {
            if (this.headerTabBarList.length != 0 )
            {
                this.openHeaderTabPage(this.headerTabBarList[$event.index]);
            }
        }
    }
    
    moveToSelectedTabPage()
    {
        if (this.headerTabBarList != null)
        {
            if (this.headerTabBarList.length != 0)
            {
                this.selectedTabIndex = this.headerTabBarList.findIndex(page => page.adRolePageRoutingUrl == this.router.url);
                if (this.selectedTabIndex == -1)
                {
                    this.selectedTabIndex = 0;
                    this.router.navigate([this.headerTabBarList[this.selectedTabIndex].adRolePageRoutingUrl]);
                }
                else
                {
                    this.router.navigate([this.headerTabBarList[this.selectedTabIndex].adRolePageRoutingUrl]);
                }
            }
            else
            {
                this.router.navigate(['/dashboard']);
            }
        }
    }
    
    receiveTabLst($event)
    {
        this.headerTabBarList = JSON.parse(localStorage.getItem("tabBarList"));
        if ($event)
        {
            this.selectedTabIndex = this.headerTabBarList.length - 1;
            this.router.navigate([this.headerTabBarList[this.headerTabBarList.length - 1].adRolePageRoutingUrl]);
        }
        else
        {
            this.selectedTabIndex = this.headerTabBarList.findIndex(page => page.adRolePageRoutingUrl == localStorage.getItem("routerUrl"));
        }
    }
    
    openHeaderTabPage(page)
    {
        this.router.navigate([page.adRolePageRoutingUrl]);
    }
    
    closeTab(pageObj: any)
    {
        var index = this.headerTabBarList.indexOf(pageObj);
        if (index > -1) 
        {
            this.headerTabBarList.splice(index, 1);
            localStorage.setItem("tabBarList", JSON.stringify(this.headerTabBarList));
            this.headerTabBarList = JSON.parse(localStorage.getItem("tabBarList"));
        }
        this.moveToSelectedTabPage();
    }
}
